import React, { useState } from "react";
import GlobalStyles from "./styles/GlobalStyles";
import ProgressBar from "./components/ProgressBar";
import Header from "./components/header/Header";
import Hero from "./components/hero/Hero";
import About from "./components/about/About";
// import Features from "./components/features/Features";
// import FeatureModal from "./components/feature-modal/FeatureModal";
import Ready from "./components/ready/Ready";
import Footer from "./components/footer/Footer";
import Features from "./components/features/Features";
import styled from "styled-components";
// import FeatureCard from "./components/features/FeatureCard";
// import { features } from "./data/FeaturesData";

export default function App() {
  const [activeFeature, setActiveFeature] = useState(null);

  return (
    <Wrapper>
      <GlobalStyles />
      <ProgressBar />
      <Header />
      <Hero />
      <About />
      <Features />
      <Ready />
      <Footer />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
